
/* injects from baggage-loader */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import LeftMenu from "../leftMenu";
import GameListWrapper from "../../components/gameListWrapper/index";
import GameWrapper from "../../containers/gameWrapper";
import {closeGameComponent} from '../../../actions/ui';
import Config from "../../../config/main";
import RegionWrapper from "../../components/RegionWrapper";

class SportsBookWrapper extends Component {
    componentWillUnmount () {
        this.props.closeGameComponent();
    }
    render () {
        let { gameType, isAsian, sportAlias, timeFilter, setTimeFilter, regionId, competitionId, child, gameArray, cursor, isGameComponentOpen } = this.props;

        return (<div className={`select-sport-contain-m ${gameType} ${isGameComponentOpen ? 'listWithEvents' : ''}`}>
            {(gameType !== 'topGames' || sportAlias !== 'all') && <>
                {Config.usaSportCompetitionConfig.includes(sportAlias) ?
                    <RegionWrapper sportAlias={sportAlias} gameType={gameType} key={sportAlias}/>
                    : (gameType !== 'topGames' || gameType === 'topGames' && !Config.hideRegionsListOnTopGames) && (<LeftMenu gameType={gameType}
                        isAsian={isAsian}
                        sportAlias={sportAlias}
                        regionId={regionId}
                        competitionId={competitionId}
                        timeFilter={timeFilter}
                        setTimeFilter={setTimeFilter} />)}
            </>}
            {
                ((regionId || competitionId) && !child) ? <GameListWrapper gameType={gameType}
                    isAsian={isAsian}
                    sportAlias={sportAlias}
                    regionId={regionId}
                    timeFilter={timeFilter}
                    competitionId={competitionId} /> : child
            }
            {
                isGameComponentOpen ? (<GameWrapper
                    params={{ sportAlias }}
                    routeParams={{ gameId: gameArray[cursor] }}
                    key={gameArray[cursor]}
                />) : null
            }
        </div>);
    }
}

SportsBookWrapper.propTypes = {
    gameType: PropTypes.string,
    isAsian: PropTypes.bool,
    sportAlias: PropTypes.any,
    timeFilter: PropTypes.any,
    setTimeFilter: PropTypes.any,
    child: PropTypes.any,
    regionId: PropTypes.any,
    competitionId: PropTypes.any,
    isGameComponentOpen: PropTypes.bool,
    gameArray: PropTypes.arrayOf(PropTypes.number),
    cursor: PropTypes.number,
    closeGameComponent: PropTypes.func
};
SportsBookWrapper.defaultProps = {
    isGameComponentOpen: false,
    gameArray: [],
    cursor: 0
};
const mapStateToProps = (state) => {
    return {
        isGameComponentOpen: state.uiState.multiComponent.bool,
        gameArray: state.uiState.multiComponent.array,
        cursor: state.uiState.multiComponent.cursor
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        closeGameComponent: () => dispatch(closeGameComponent())
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SportsBookWrapper);